module.exports = __webpack_public_path__ + "img/logo-w.20a0adff.png";